import { render, staticRenderFns } from "./CreatePromotion.vue?vue&type=template&id=01502d6a"
import script from "./CreatePromotion.vue?vue&type=script&lang=js"
export * from "./CreatePromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports